import { ShareOutlined } from '@mui/icons-material';
import { Button, Dialog, SxProps } from '@mui/material';

import ShareDialogContent from '@/pages/Markets/MarketsComponents/Share/ShareDialogContent';
import getFactsheetLink from '@/utils/getFactsheetLink';

import useShareButton from './useShareButton';

const ShareButton = ({
  title,
  additionalTitle,
  code,
  sx,
  iconSize = 24
}: {
  title?: string;
  additionalTitle?: string;
  code?: string;
  sx?: SxProps;
  iconSize?: number;
}) => {
  const {
    modalOpen,
    setModalOpen,
    content,
    setContent,
    recipient,
    handleChangeRecipient,
    handleCopyToClipboard,
    sendEmail,
    emailError
  } = useShareButton(code);

  const shareUrl = getFactsheetLink(code);
  const headerSuffix = additionalTitle ? ` / ${additionalTitle}` : '';
  const header = `Share ${title}${headerSuffix}`;
  return (
    <>
      <Button
        color='secondary'
        sx={{ width: 192, height: 48, fontSize: '16px', ...sx }}
        variant='contained'
        onClick={() => {
          setModalOpen(true);
        }}
      >
        <ShareOutlined
          sx={{
            width: iconSize,
            height: iconSize
          }}
        />
        Share
      </Button>
      <Dialog
        open={modalOpen}
        sx={{
          zIndex: 9999,
          '& .MuiDialog-container': {
            backgroundColor: 'rgba(18, 22, 63, 0.40)'
          }
        }}
        onClose={() => {
          setModalOpen(false);
        }}
      >
        <ShareDialogContent
          content={content}
          emailError={emailError}
          handleChangeRecipient={e => {
            handleChangeRecipient(e.target.value);
          }}
          header={header}
          recipient={recipient}
          shareUrl={shareUrl}
          onContentChange={e => {
            setContent(e.target.value);
          }}
          onCopyClick={handleCopyToClipboard}
          onSendEmail={sendEmail}
        />
      </Dialog>
    </>
  );
};

export default ShareButton;
